import { render } from "./ListePoids.vue?vue&type=template&id=7ae09693&ts=true"
import script from "./ListePoids.vue?vue&type=script&lang=ts"
export * from "./ListePoids.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__